import { render, staticRenderFns } from "./TenderStep.vue?vue&type=template&id=77ed8504&scoped=true"
import script from "./TenderStep.vue?vue&type=script&lang=js"
export * from "./TenderStep.vue?vue&type=script&lang=js"
import style0 from "./TenderStep.vue?vue&type=style&index=0&id=77ed8504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed8504",
  null
  
)

export default component.exports